import React from 'react'
// import assets from '../../utils/assets';
import "./industriesStyles.scss"
import styles from "../../pages/pages.module.scss";
import '../pricing/styles.scss'

const Hero = () => {
    return (
        <div className="heroMarginTop">
            <div className="container">

                {/* New UI */}
                <div className={`row ${styles.sectionheading}`}>
                    <h3 className='col text-md-start'>Industries</h3>
                    <div className='align-items-center align-items-md-start col-md-8 d-flex flex-column'>
                        <h4 className='text-md-start mt-md-0 '> Accounting is the systematic process of recording, analyzing, and interpreting financial transactions and information for organizations and individuals.</h4>
                        <div className="ctabtn">Contact Sales</div>
                    </div>
                </div>

                {/* Old UI */}
                {/* <div className="row">
                    <div className={` align-items-center d-flex flex-column ${styles.sectionheading}`}>
                        <h3>
                            Industries
                        </h3>
                        <h4 className='col-xl-6'>Accounting is the systematic process of recording, analyzing, and interpreting financial transactions and information for organizations and individuals.</h4>
                    </div>
                </div> */}

                {/* <div className="row hero row-gap-4">
                    <div className="col-12 col-sm">
                        <img src={assets.IHimg1} alt="img1" className="img-fluid" />
                    </div>
                    <div className="col-12 col-sm d-none d-sm-block">
                        <img src={assets.IHimg2} alt="img2" className=" img-fluid" />

                    </div>
                    <div className="col-12 col-sm d-none d-sm-block">
                        <img src={assets.IHimg3} alt="img3" className=" img-fluid" />
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default Hero;